import React, { useEffect, Fragment } from 'react';
import { Button, Row, Col, ProgressBar } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Message from '../components/Message';
import Loader from '../components/Loader';
import MainContainer from '../components/MainContainer';
import {
  answerQuestion,
  startNewQuiz,
  resetQuiz,
} from '../actions/answerActions';
import TitledQuestion from '../components/TitledQuestion';
import LabeledQuestion from '../components/LabeledQuestion';

const QuizScreen = ({ history, location }) => {
  const dispatch = useDispatch();
  const { loading, error, answer } = useSelector((state) => state.userAnswer);

  useEffect(() => {
    if (!loading) {
      if (answer.created_at === undefined) {
        dispatch(startNewQuiz());
      } else {
        if (answer.completed) {
          history.push('/results');
        }
      }
    }
  }, [dispatch, answer.completed, answer.created_at, loading, history]);

  const handleBack = (e) => {
    e.preventDefault();
    history.push('/dashboard');
  };

  const handleOptionSelected = (e, optionIndex) => {
    e.preventDefault();
    dispatch(
      answerQuestion(answer.id, answer.current_question.id, optionIndex)
    );
    // if (currentQuestion === answer.number_of_questions - 1) {
    //   dispatch(saveQuestion());
    //   history.push(`/results`);
    // } else {
    //   setCurrentQuestion(currentQuestion + 1);
    // }
  };

  const handleReset = (e) => {
    e.preventDefault();
    dispatch(resetQuiz());
  };

  const renderQuestion = () => {
    switch (answer.current_question.type) {
      case 'multiple_choice':
        return (
          <TitledQuestion
            index={answer.current_question.index}
            answer={answer.current_question}
            handleOptionSelected={handleOptionSelected}
          />
        );
      case 'slider':
        return (
          <LabeledQuestion
            index={answer.current_question.index}
            question={answer.current_question}
            handleOptionSelected={handleOptionSelected}
          />
        );
      default:
        return null;
    }
  };

  return (
    <MainContainer>
      <h4
        className='text-secondary'
        style={{ marginBottom: '0', paddingBottom: '0' }}
      >
        Análise de perfil
      </h4>
      <p className='text-secondary mb-4'>
        Responda às seguintes questões e entenda seu perfil
      </p>
      {error && <Message variant='danger'>{error}</Message>}
      {loading ||
      !(answer.created_at !== undefined) ||
      answer.last_answered_question === answer.number_of_questions ? (
        !error && <Loader />
      ) : (
        <Fragment>
          <ProgressBar
            max={answer.number_of_questions}
            now={answer.current_question.index}
            label={`${answer.current_question.index} de ${answer.number_of_questions}`}
            className='my-5'
          />
          {renderQuestion()}
          {/* {answer.answers[currentQuestion].title ? (
            <TitledQuestion
              index={currentQuestion + 1}
              answer={answer.answers[currentQuestion]}
              handleOptionSelected={handleOptionSelected}
            />
          ) : (
            <LabeledQuestion
              index={currentQuestion + 1}
              answer={answer.answers[currentQuestion]}
              handleOptionSelected={handleOptionSelected}
            />
          )} */}
          <Row className='mt-5'>
            <Col>
              <Button type='button' variant='link' onClick={handleBack}>
                <i className='fas fa-arrow-left'></i> Voltar
              </Button>
            </Col>
            <Col className='text-right'>
              <Button type='button' variant='link' onClick={handleReset}>
                Reiniciar
              </Button>
            </Col>
          </Row>
        </Fragment>
      )}
    </MainContainer>
  );
};

export default QuizScreen;
